// extracted by mini-css-extract-plugin
export default {"body":"G01027d","bottom":"G543a1b","firstButton":"G681cf7","modalTitle":"G898805","modalBodyText":"Gd4e277"};